import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AiFlashcards } from './aiFlashcards';

const routes: Routes = [
  {
    path: '',
    component: AiFlashcards
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AiFlashcardsRoutingModule {}
